import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconUserSwitch: FC<IconProps> = ({ $size, ...rest }) => (
  <IconNonFilledStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 35 33" fill="none">
      <circle cx="16" cy="17" r="16" fill="white" />
      <path
        d="M16 20C18.7614 20 21 17.7614 21 15C21 12.2386 18.7614 10 16 10C13.2386 10 11 12.2386 11 15C11 17.7614 13.2386 20 16 20Z"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.97498 24.925C8.72736 23.443 9.87542 22.1983 11.2919 21.3289C12.7084 20.4595 14.3379 19.9992 16 19.9992C17.662 19.9992 19.2916 20.4595 20.708 21.3289C22.1245 22.1983 23.2726 23.443 24.025 24.925"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 16L28 19L31 16"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 16L4 13L7 16"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 19V16C28.0028 13.4073 27.1659 10.8835 25.6144 8.80623C24.063 6.72898 21.8806 5.21005 19.3937 4.47681C16.9069 3.74357 14.2495 3.83546 11.8193 4.73873C9.38904 5.64199 7.31671 7.30805 5.91248 9.48751"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.00001 13V16C3.99718 18.5927 4.83411 21.1165 6.38554 23.1938C7.93696 25.271 10.1194 26.79 12.6062 27.5232C15.0931 28.2564 17.7505 28.1646 20.1807 27.2613C22.6109 26.358 24.6833 24.692 26.0875 22.5125"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="28" cy="25" r="7" fill="white" />
      <path
        d="M27.2625 27.275L30.8 23.7375L30.225 23.175L27.2625 26.1375L25.7625 24.6375L25.2 25.2L27.2625 27.275ZM28 30C27.3167 30 26.6708 29.8687 26.0625 29.6062C25.4542 29.3438 24.9229 28.9854 24.4688 28.5312C24.0146 28.0771 23.6562 27.5458 23.3937 26.9375C23.1312 26.3292 23 25.6833 23 25C23 24.3083 23.1312 23.6583 23.3937 23.05C23.6562 22.4417 24.0146 21.9125 24.4688 21.4625C24.9229 21.0125 25.4542 20.6562 26.0625 20.3937C26.6708 20.1312 27.3167 20 28 20C28.6917 20 29.3417 20.1312 29.95 20.3937C30.5583 20.6562 31.0875 21.0125 31.5375 21.4625C31.9875 21.9125 32.3438 22.4417 32.6062 23.05C32.8687 23.6583 33 24.3083 33 25C33 25.6833 32.8687 26.3292 32.6062 26.9375C32.3438 27.5458 31.9875 28.0771 31.5375 28.5312C31.0875 28.9854 30.5583 29.3438 29.95 29.6062C29.3417 29.8687 28.6917 30 28 30Z"
        fill={colors[rest?.$color]}
      />
    </svg>
  </IconNonFilledStyled>
);

IconUserSwitch.defaultProps = iconDefaultProps;
IconUserSwitch.displayName = 'IconUserSwitch';

export default IconUserSwitch;
